import React from 'react';
import { AD_APP_TYPES, normalizeAdAppTypes } from '../utils/advertisingUtils';

const BADGE_COLORS = {
  Playground: { background: '#e8f5e9', color: '#2e7d32' },
  Castle: { background: '#f3e5f5', color: '#7b1fa2' },
  ChristmasMarkets: { background: '#ffebee', color: '#c62828' },
  Waterfall: { background: '#e3f2fd', color: '#1565c0' },
};
const UNIVERSAL_COLORS = { background: '#eeeeee', color: '#555' };
const UNKNOWN_COLORS = { background: '#fff3e0', color: '#e65100' };

const badgeStyle = (colors) => ({
  ...colors,
  fontSize: 11,
  fontWeight: 600,
  padding: '2px 8px',
  borderRadius: 999,
  whiteSpace: 'nowrap',
});

export function AppTypesBadges({ ad }) {
  const selected = normalizeAdAppTypes(ad);
  return (
    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', margin: '2px 0' }}>
      {selected.length === 0 ? (
        <span style={badgeStyle(UNIVERSAL_COLORS)}>All apps</span>
      ) : (
        selected.map((value) => (
          <span key={value} style={badgeStyle(BADGE_COLORS[value] || UNKNOWN_COLORS)}>
            {AD_APP_TYPES.find((t) => t.value === value)?.label || value}
          </span>
        ))
      )}
    </div>
  );
}

export default function AppTypesField({ value, onChange }) {
  const selected = normalizeAdAppTypes({ appTypes: value });

  const toggle = (type, checked) => {
    const next = checked ? [...selected, type] : selected.filter((t) => t !== type);
    onChange(normalizeAdAppTypes({ appTypes: next }));
  };

  return (
    <fieldset style={{ border: 'none', padding: 0, margin: 0 }}>
      <legend style={{ fontWeight: 500, fontSize: 15, marginBottom: 4, padding: 0 }}>App types</legend>
      <div style={{ fontSize: 13, color: 'var(--color-text-secondary)', marginBottom: 8 }}>
        Leave all unchecked to show this ad in every app.
      </div>
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
        {AD_APP_TYPES.map((type) => (
          <label key={type.value} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 15 }}>
            <input
              type="checkbox"
              checked={selected.includes(type.value)}
              onChange={(e) => toggle(type.value, e.target.checked)}
              style={{ width: 18, height: 18 }}
            />
            {type.label}
          </label>
        ))}
      </div>
    </fieldset>
  );
}
